import { OneDSPropertyFormatter } from './formatters/log-property-formatter';
import { IDefaultConfig } from '../types';

const propertyFormatter = new OneDSPropertyFormatter();

export const defaultConfig: IDefaultConfig = {
  formatters: { propertyFormatter },
  transmitProfile: 'REAL_TIME',
  batchSize: 50,
};
